import { connect } from "react-redux";

import NotFound from "./NotFound";

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NotFound);
